import React from "react";
import Placeholder from "../Placeholder";

function PortfolioItemBackBtnPlaceholder() {
    return (
        <Placeholder style={{ width: "3.75rem", height: "3.75rem", top: 0, left: 0, position: "absolute", borderRadius: ".937rem 50% 50% 50%", boxShadow: "0 8px 16px rgba(100, 100, 100,.15),0 24px 40px rgba(100, 100, 100,.2)" }} />
    );
}

export default PortfolioItemBackBtnPlaceholder;